import { Column, Entity, Index, PrimaryGeneratedColumn } from "typeorm";

@Index("class", ["class"], {})
@Index("subject", ["subject"], {})
@Index("qno", ["qno"], {})
@Index("marks", ["marks"], {})
@Index("estatus", ["estatus"], {})
@Entity("createquestion")
export class CreateQuestion {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "class" })
  class: number;

  @Column("int", { name: "subject" })
  subject: number;

  @Column("int", { name: "chapter" })
  chapter: number;

  @Column("int", { name: "topic" })
  topic: number;

  @Column("int", { name: "qno" })
  qno: number;

  @Column("longtext", { name: "question" })
  question: string;

  @Column("int", { name: "marks" })
  marks: number;

  @Column("int", { name: "complexity" })
  complexity: number;

  @Column("int", { name: "qtype" })
  qtype: number;

  @Column("int", { name: "language" })
  language: number;

  @Column("varchar", { name: "username", length: 30 })
  username: string;

  @Column("varchar", { name: "approvedby", length: 30,nullable:true })
  approvedby: string;

  @Column("varchar", { name: "timestamp", length: 20 ,nullable:true})
  timestamp: string;

  @Column("varchar", { name: "etimestamp", length: 20 ,nullable:true})
  etimestamp: string;

  @Column("int", { name: "estatus" ,nullable:true})
  estatus: number;
  
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @Column("varchar", { name: "user_one" })
  userOne: string;

  @Column("varchar", { name: "user_two" })
  userTwo: string;

  @Column("varchar", { name: "user_three" })
  userThree: string;

  @Column("varchar", { name: "user_four" })
  userFour: string;

  @Column("varchar", { name: "user_five" })
  userFive: string;
}
